export default __webpack_public_path__ + "static/scores-aacd9fc6b13d9a04e01294e7de9c9ea9.png";